module.exports = __webpack_public_path__ + "static/media/ye.dc0bba07.svg";